import { IPeriodOption } from "./data";
import React, { useContext } from "react";
import { Box, Grid, } from "@material-ui/core";
import { Typography } from "../../../../../../common/components/libs";
import PageStoreContext from "../../context";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../hooks";
import { SnackbarType } from "../../../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";


const useStyles = makeStyles({
    block: {
        background: '#fff',
        border: '1px solid #efefef',
        cursor: "pointer",
        transaction: "background-color 0.2s",
        "&:hover":{
            background: '#f3f3f3',
        },
        height: "100%"
    },
    selected: {
        background: '#f3f3f3',
    }
})


interface Props{
    period: IPeriodOption
}
const PeriodOption = (props: Props) => {
    const pageStore = useContext(PageStoreContext);
    const period = props.period;
    const styles = useStyles();
    const {generalStore} = useStores();
    const {i18n, t} = useTranslation(["general", "stats"]);


    const isSelected = pageStore.period.title === period.title;

    return <Grid item md={6} xs={6} lg={6}>
        <div
            className={[styles.block, isSelected ? styles.selected : undefined].join(" ")}
            onClick={() => {
                pageStore.setPeriodOption(period)
                pageStore.setTimeInterval(period.from, period.to);
                generalStore.showSnackbar({
                    type: SnackbarType.success,
                    title: t("general:labelOfUpdating")
                })
            }}
        >
            <Box p={2}>
                <Typography variant='body1'>
                    {t(`stats:${period.title}`)}
                    {/*{period.title}*/}
                </Typography>
            </Box>
        </div>
    </Grid>
};


export default observer(PeriodOption);
